import { EFileFormat } from '@/models'
class CheckFileFormat {

  getFileFormatWithFileName(fileName: string): EFileFormat {
    const fileNameSplit: string[] = fileName.split('.')
    const extention = fileNameSplit[fileNameSplit.length - 1]
    return this.getFileFormat(extention)
  }

  getIconClassNameWithFileName(fileName: string) {
    const fileNameSplit: string[] = fileName.split('.')
    const extention = fileNameSplit[fileNameSplit.length - 1]
    const format = this.getFileFormat(extention)
    return this.getIconClassName(format)
  }

  getIconClassNameWithFileExtention(fileExtention: string) {
    const format = this.getFileFormat(fileExtention)
    return this.getIconClassName(format)
  }

  getFileFormat(extension: string): EFileFormat {
    if (!extension) return EFileFormat.OTHER
    const fileExtension = extension?.toLowerCase()
    if ('jpg,jpeg,png,gif'.includes(fileExtension)) return EFileFormat.IMAGE
    if ('mp4,mov,wmv,avi'.includes(fileExtension)) return EFileFormat.VIDEO
    if ('zip'.includes(fileExtension)) return EFileFormat.ZIP
    if ('xlsx,xls'.includes(fileExtension)) return EFileFormat.EXCEL
    if ('csv'.includes(fileExtension)) return EFileFormat.CSV
    if ('pdf'.includes(fileExtension)) return EFileFormat.PDF
    return EFileFormat.OTHER
  }

  getIconClassName(format: EFileFormat) {
    switch (format) {
      case EFileFormat.IMAGE:
        return 'far fa-file-image'
      case EFileFormat.VIDEO:
        return 'far fa-file-video'
      case EFileFormat.ZIP:
        return 'far fa-file-archive'
      case EFileFormat.EXCEL:
        return 'far fa-file-excel'
      case EFileFormat.CSV:
        return 'far fa-file-csv'
      case EFileFormat.PDF:
        return 'far fa-file-pdf'
      case EFileFormat.OTHER:
        return 'far fa-file'
      default:
        return ''
    }
  }
}

export default new CheckFileFormat()